import type { IconSvgObject } from './types';

const DeviantartIcon: IconSvgObject = [
  ["path", { d: "M19 6.5V2H15.5L12.5 6.5H5V11H9.5L5 17.5V22H8.5L11.5 17.5H19V13H14.5L19 6.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default DeviantartIcon;
